import './SpaceSidebarContainer.css'
import { SelectedSpaceHeader } from './selected-space-header/SelectedSpaceHeader.tsx'
import { useState } from 'react'
import type { ISpacesService } from '../services/SpacesService'
import { SelectSpacePanel } from './SelectSpacePanel.tsx'
import { CollectionsExplorer } from '../../objects/collections-tree/CollectionsExplorer.tsx'
import clsx from 'clsx'
import { ObjectTypesExplorer } from '../../object-types/ObjectTypesExplorer.tsx'
import type { SpaceGqlModel } from '../gql/SpaceGqlModel'
import { Divider } from '@mui/material'
import { useDiRef } from '@/common/react/di-hooks'
import { useBehaviorObservable } from '@/common/react/observable-hooks'

interface SpaceSidebarContainerProps {
  sidebarOpen: boolean
}

export function SpaceSidebarContainer({ sidebarOpen }: SpaceSidebarContainerProps) {
  const [isSelectingSpace, setIsSelectingSpace] = useState(false)
  const spacesService = useDiRef<ISpacesService>('SpacesService')
  const selectedSpace = useBehaviorObservable(spacesService.selectedSpace$)
  const spaces = useBehaviorObservable(spacesService.spaces$)
  const isFetched = !!(spaces && selectedSpace)
  if (!isFetched) {
    return null
  }

  function onSpaceSelected(space: SpaceGqlModel) {
    spacesService.setSelectedSpace(space)
    setIsSelectingSpace(false)
  }

  function onSelectSpaceHeaderClicked() {
    setIsSelectingSpace(true)
  }

  return (
    <div className={clsx('spaceSidebarContainer', { open: sidebarOpen })}>
      {isSelectingSpace ? (
        <SelectSpacePanel
          selectedSpace={selectedSpace}
          spaces={spaces}
          onSpaceSelected={onSpaceSelected}
        />
      ) : (
        <>
          <SelectedSpaceHeader selectedSpace={selectedSpace} onClick={onSelectSpaceHeaderClicked} />
          <Divider />
          <CollectionsExplorer spaceId={selectedSpace.id} />
          <Divider />
          <ObjectTypesExplorer spaceId={selectedSpace.id} />
        </>
      )}
    </div>
  )
}
